import React from 'react';
import OptimizedImage from '../OptimizedImage';

/** Lazy grid thumbnail with WebP when the CDN or /public companion supports it. */
export default function BlogCardThumb({ src, alt }) {
  return (
    <OptimizedImage
      src={src}
      alt={alt}
      className="blog-card-thumb"
      loading="lazy"
      decoding="async"
      fetchPriority="low"
      width={640}
      height={360}
      sizes="(max-width: 480px) 100vw, (max-width: 960px) 50vw, 320px"
    />
  );
}
